// Browser entry point - no image processing
import { browserImageOps } from "../image/adapters/browser";

// Re-export all types and functions from the main index
export * from "../index";

// Override the image operations with Browser-specific implementation
import { imageOps } from "../index";
imageOps.svgToPng = browserImageOps.svgToPng;
imageOps.isAvailable = browserImageOps.isAvailable;
